import { useLocation, useParams } from 'react-router-dom'

import VehicleEdit from './VehicleEdit'

const VehicleEditPage: React.FC = () => {
  // Extracting id parameter from the route
  const { id } = useParams<{ id: string }>()
  const location = useLocation()
  // Extracting "mode" parameter from the state
  // Seteado en la pagina VehicleDetail en el botón Editar
  const { mode, pageState } = location.state || false // safely access mode

  // No le  pasamos onReturn, porque el onReturn se usa cuando estamos en
  // la reserva creando un auto a usar como pago
  return <VehicleEdit id={id} mode={mode} pageState={pageState} />
}
export default VehicleEditPage
